// This is copied from the patient portal frontend

import { useRecoilValue } from "recoil";
import { useLocation, Redirect, Route } from "react-router-dom";
import { getUserAuth } from "../recoil/selectors";
import { LOGIN_PAGE_URL } from "../utils/urlConstants";

export const ProtectedRoute = ({
  component: Component,
  ...rest
}: {
  // We actually want to allow any here
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: React.ComponentType<any>;
  [key: string]: unknown;
}) => {
  const { pathname } = useLocation();
  const auth = useRecoilValue(getUserAuth);

  // If the user is not authenticated, save the current pathname to redirect to after login
  if (!auth?.token) {
    sessionStorage.setItem(
      "current-pathname",
      `${pathname}${window.location.search}`,
    );
    return <Route {...rest} render={() => <Redirect to={LOGIN_PAGE_URL} />} />;
  }

  return <Route {...rest} render={(props) => <Component {...props} />} />;
};
